import React, { useState, useEffect } from 'react'
import { contentList } from 'src/services/ContentApi'
import { useSelector } from 'react-redux'

import PropTypes from 'prop-types'
import Loader from '../Loader'
import SetInnerHtml from '../SetInnerHtml'

function VideoPlayer({ videoIndex = 0, onHide }) {
  const [videoData, setVideoData] = useState([])
  const [loading, setLoading] = useState(true)
  const language = useSelector((state) => state.language)

  useEffect(() => {
    const getData = async () => {
      setLoading(true)
      try {
        const data = await contentList('lst_videos', language)
        setVideoData(data)
      } catch (error) {
        throw error
      }
      setLoading(false)
    }
    getData()
  }, [language])

  if (loading) return <Loader />
  const videoSource = videoData[videoIndex]?.htm_video_source

  return (
    <>
      <button type="button" className="close border-0 m t-1 p-0 fw-bold" onClick={onHide}>
        ×
      </button>
      <SetInnerHtml tag="div" className="video-margin" content={videoSource} />
    </>
  )
}
VideoPlayer.propTypes = {
  videoIndex: PropTypes.number,
  onHide: PropTypes.func,
}

export default VideoPlayer
